module.exports = __webpack_public_path__ + "img/united-states.888b8de1.png";